import {
  COLOR_DARK_BLUE,
  COLOR_DARK_RED,
  COLOR_ELEVATION,
  COLOR_PRIMARY_BLACK,
  COLOR_PRIMARY_GREEN,
  COLOR_PRIMARY_RED,
  radius,
  spacing,
} from "./../../styleConfig";
import styled from "styled-components";

interface IInput {
  error?: boolean;
  errorMsg?: string;
}

interface IMainContainer {
  wasFocused: boolean;
}

export const MainContainer = styled.div<IMainContainer>`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  height: fit-content;
  width: 100%;
  min-width: 200px;

  & svg {
    position: absolute;
    opacity: ${(p) => (p.wasFocused ? "0" : "1")};
    right: 10px;
    z-index: 0;
    transition: 0.2s;
  }

  :focus-within svg {
    opacity: 0;
  }
`;

export const InputContainer = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const Input = styled.input<IInput>`
  height: 100%;
  width: 100%;
  border: none;
  border-bottom: 2px solid
    ${(p) => (p.error ? COLOR_PRIMARY_RED : COLOR_PRIMARY_BLACK)};
  outline: none;
  padding-left: ${spacing(1.5)};
  padding-right: ${spacing(1.5)};
  transition: 0.3s;
  font-size: 15px;
  background-color: transparent;

  &:focus {
    border-bottom: 2px solid
      ${(p) => (p.error ? COLOR_PRIMARY_RED : COLOR_PRIMARY_GREEN)};
  }
`;

interface IInputLabel {
  error?: boolean;
  errorMsg?: string;
}

export const InputLabel = styled.label<IInputLabel>`
  position: absolute;
  user-select: none;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  color: ${(p) => (p.error ? COLOR_PRIMARY_RED : COLOR_PRIMARY_BLACK)};
  font-weight: 700;
  left: 0%;
  font-size: 15px;
  transition: 0.5s;
`;

export const ErrorMsg = styled.p`
  color: ${COLOR_PRIMARY_RED};
  font-size: 12px;
  margin-top: ${spacing(0.5)};
  text-align: center;
  max-width: 100%;
`;
